import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <div className=" footer">
      <div className="footer_text">
          <h4 className="question">
              Question? Contact us.
          </h4>
          <h5 className="notices">
              <a href="netflix.com">Terms of use</a>
              <a href="netflix.com">Jobs</a>
              <a href="netflix.com">Connect</a>
              <a href="netflix.com">Subscription</a>
              <a href="netflix.com">Help Centre</a>
              <a href="netflix.com">Contact Us</a>
          </h5>
      </div>

      <div className="languages">
        <select className="langauge">
          <option value="volvo">English</option>
          <option value="saab">French</option>
          <option value="mercedes">German</option>
          <option value="audi">Hausa</option>
        </select>
      </div>
      <div>
          <h5>
              Netflix nigeria
          </h5>
      </div>
    </div>
  );
}

export default Footer;
